import useSWRImmutable from 'swr/immutable';

import { ImageFade } from '@rikstv/play-common/src/components/imageFade/ImageFade';
import { Link } from '@rikstv/play-common/src/router/Link';
import { Body, H2, Tag } from '@rikstv/shared-components';

import { getLastPublishedStrimetips } from '../../../../apis/sanityClient';

import style from './TipShortcut.module.css';

let randomNr = 0;
const StrimetipsComponent = () => {
  const { data, isLoading } = useSWRImmutable('last-strimetips', () => getLastPublishedStrimetips());

  if (isLoading || !data) {
    return null;
  }

  // assign random tip to display
  if (data && randomNr === 0) {
    randomNr = Math.floor(Math.random() * data.length);
  }

  const { listContent, slug, category } = data[randomNr];
  const { image, title, description } = listContent;

  // On localhost, link to prod to ensure article exists
  const absoluteUrl =
    location.hostname === 'localhost'
      ? `http://www.strim.no/strimetips/${slug.current}`
      : `/strimetips/${slug.current}`;
  return (
    <div className={style.tip}>
      <div>
        <Tag className={style.tag}>{category.name}</Tag>
      </div>
      <div className={style.content}>
        <H2>{title}</H2>
        <Body>{description}</Body>
        <Body>
          <Link to={absoluteUrl}>Les mer</Link>
        </Body>
      </div>
      <div className={style.image}>
        <ImageFade
          src={`${image.asset.url}?w=992&q=75&fit=clip&auto=format`}
          alt={image.asset.altText || title}
          className={style.img}
        />
      </div>
    </div>
  );
};

export const TipShortcut = () => (
  <div>
    <StrimetipsComponent />
  </div>
);
